import React from "react";
import ToolLayout from "../ToolLayout";
import FinancingWidget from "../../FinancingWidget";
import BrandText from "../../../branding/BrandText";

const FinancingPage = () => {
  return (
    <ToolLayout
      title="Explore Monthly Financing"
      description={
        <BrandText>
          We know starting a new project can be a lot! Home-Helper makes it easy to get the financing for your home improvement project!
        </BrandText>
      }
    >
      <FinancingWidget />
    </ToolLayout>
  );
};

export default FinancingPage;
